export const NAME = 'headerBar';